// store/facilityStore.js
import { create } from 'zustand';
import { getFacilities } from '../api/providerApi';

const useFacilityStore = create((set, get) => ({
    facilities: [],
    loading: false,
    error: null,

    fetchFacilities: async () => {
        set({ loading: true, error: null });
        try {
            const data = await getFacilities();
            set({ facilities: data, loading: false });
        } catch (err) {
            set({
                error: err.message || 'Failed to load facilities',
                loading: false,
            });
        }
    },

    // ✅ NO hard coding
    getFacilityNameById: (id) => {
        const facility = get().facilities.find(
            (f) => f.Facility_ID === Number(id)
        );
        return facility?.FacilityName || `Service #${id}`;
    },
}));

export default useFacilityStore;
